var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed, onBeforeUnmount, ref } from 'vue';
import OrderForm from '@common/components/Landing/OrderForm/OrderForm.vue';
import { AuthModalStore, CoreStore, CourseStore } from '@student/modules/store';
import { apiErrorsHandle, openLink } from '@common/utils/Helpers/Helpers';
import Api from '@student/modules/api/api';
import Auth, { AuthEvents } from '@common/modules/auth';
import Message from '@common/ui/EMessage/Message';
import getClientFingerprint from '@common/utils/ClientFingerprint';
import analytics from '@common/utils/Analytics/Analytics';
import { planFeatures } from '@common/utils/Plans';
import { studentLandingApi } from '@student/modules/api/landing/landing.api';
import { useEventBus } from '@vueuse/core';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'LandingOrderForm',
    setup: function (__props, _a) {
        var _this = this;
        var __emit = _a.emit;
        var t = useI18n().t;
        var props = __props;
        var emit = __emit;
        var busSignIn = useEventBus(AuthEvents.AUTH_SIGNED_IN);
        var busAuthCancelled = useEventBus(AuthEvents.AUTH_CANCELLED);
        var landingOrderFormVisibility = computed(function () { return CourseStore.landingOrderFormVisibility; });
        var landingOrderFormPlan = computed(function () { return CourseStore.landingOrderFormPlan; });
        var landingPurchaseLoading = computed(function () { return CourseStore.landingPurchaseLoading; });
        var user = computed(function () { return CoreStore.user; });
        var course = computed(function () { return CourseStore.course; });
        var landing = computed(function () { return CourseStore.landing; });
        var userFieldsValues = computed(function () { return CourseStore.userFieldsValues; });
        var promocode = ref();
        var loadingCheckDiscount = ref(false);
        var savedFields = ref();
        var canUsePromoCodes = computed(function () {
            return CoreStore.canUseFeature(planFeatures.COURSE_DISCOUNT_FEATURE);
        });
        onBeforeUnmount(function () {
            unsubscribeAuthEvents();
        });
        var onOrderFormHide = function () {
            CourseStore.landingOrderFormVisibility = false;
            CourseStore.landingOrderFormPlan = null;
        };
        var proceedPayment = function () {
            CourseStore.enableStoreStateClear();
            unsubscribeAuthEvents();
            // Если у школы стоит ссылка на свою платежку и курс платный - направляем туда
            if (course.value.customPaymentLink
                && ((landingOrderFormPlan.value === null && course.value.price > 0)
                    || (landingOrderFormPlan.value !== null && landingOrderFormPlan.value.price > 0))) {
                openLink(course.value.customPaymentLink);
                CourseStore.landingPurchaseLoading = false;
            }
            else {
                CourseStore.landingPurchaseLoading = true;
                var paymentLink = new URL(document.location);
                if (savedFields.value.payment === 'installment') {
                    paymentLink.searchParams.append('installmentOrdered', '');
                }
                else {
                    paymentLink.searchParams.append('payment-success', '');
                }
                var getCoursePaymentLink = void 0;
                var _a = savedFields.value, payment = _a.payment, discount = _a.discount, customFields = _a.customFields;
                // eslint-disable-next-line unicorn/prefer-ternary
                if (landingOrderFormPlan.value === null) {
                    getCoursePaymentLink = Api.getCourseLandingPaymentLink(landing.value.id, {
                        paymentType: payment,
                        returnUrl: paymentLink.toString(),
                        discount: discount && discount.length > 0 ? discount : undefined,
                        fields: customFields
                    });
                }
                else {
                    getCoursePaymentLink = Api.getCoursePlanPaymentLink(landingOrderFormPlan.value.plan, {
                        paymentType: payment,
                        returnUrl: paymentLink.toString(),
                        discount: discount && discount.length > 0 ? discount : undefined,
                        fields: customFields
                    });
                }
                getCoursePaymentLink
                    .then(function (res) {
                    var data = res.data, paymentLink = data.gatewayPaymentLink;
                    CourseStore.landingPurchaseLoading = false;
                    if (paymentLink) {
                        document.location.href = paymentLink;
                    }
                    else {
                        document.location.reload();
                    }
                })
                    .catch(function (err) {
                    CourseStore.landingPurchaseLoading = false;
                    apiErrorsHandle(err, {
                        'COURSE_ALREADY_PAID': t('errors.COURSE_ALREADY_PAID'),
                        'COURSE_PLAN_NOT_FOUND': t('errors.COURSE_PLAN_NOT_FOUND')
                    });
                });
            }
        };
        var buyCourse = function (fields) { return __awaiter(_this, void 0, void 0, function () {
            var email, _a, _b;
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        email = Auth.isGuest() ? fields.email : user.value.email;
                        // Нужно чтобы в дальнейшем взять поля в proceedPayment
                        savedFields.value = fields;
                        CourseStore.landingPurchaseLoading = true;
                        return [4 /*yield*/, CourseStore.disableStoreStateClear()];
                    case 1:
                        _d.sent();
                        if (!Auth.isGuest()) return [3 /*break*/, 3];
                        _b = (_a = Auth).register;
                        _c = {
                            email: email
                        };
                        return [4 /*yield*/, getClientFingerprint()];
                    case 2:
                        _b.apply(_a, [(_c.fingerprint = _d.sent(),
                                _c)]).then(function () {
                            analytics.track('$registered', { '$email': email, });
                            CourseStore.landingPurchaseLoading = false;
                            proceedPayment();
                        }).catch(function (err) {
                            var registeredModal = function () {
                                // Подписываемся на события окна авторизации
                                subscribeAuthEvents();
                                // Если уже зарегистрирован - просим войти
                                AuthModalStore.showLogin();
                                setTimeout(function () {
                                    Message.error({
                                        message: t('errors.USER_EXISTS'),
                                        duration: 6000,
                                    });
                                }, 100);
                            };
                            apiErrorsHandle(err, {
                                'EMAIL_EXISTS': registeredModal,
                                'USER_EXISTS': registeredModal
                            });
                            CourseStore.landingPurchaseLoading = false;
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        CourseStore.landingPurchaseLoading = false;
                        proceedPayment();
                        _d.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        var checkDiscount = function (code) { return __awaiter(_this, void 0, void 0, function () {
            var _a, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        loadingCheckDiscount.value = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        _a = promocode;
                        return [4 /*yield*/, studentLandingApi.checkDiscount(landing.value.slug, code)];
                    case 2:
                        _a.value = (_b.sent()).data;
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _b.sent();
                        apiErrorsHandle(e_1, {
                            COURSE_DISCOUNT_NOT_FOUND: t('errors.COURSE_DISCOUNT_NOT_FOUND')
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        loadingCheckDiscount.value = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        var cancelledAuth = function () {
            unsubscribeAuthEvents();
            Message.warning(t('errors.AUTH_REQUIRED'));
        };
        var subscribeAuthEvents = function () {
            busSignIn.on(proceedPayment);
            busAuthCancelled.on(cancelledAuth);
        };
        var unsubscribeAuthEvents = function () {
            busSignIn.off(proceedPayment);
            busAuthCancelled.off(cancelledAuth);
        };
        return function (_ctx, _cache) {
            var _a;
            return (_openBlock(), _createBlock(OrderForm, {
                "can-use-promo-codes": canUsePromoCodes.value,
                course: course.value,
                landing: landing.value,
                "loading-check-discount": loadingCheckDiscount.value,
                plan: landingOrderFormPlan.value,
                promocode: promocode.value,
                "purchase-loading": landingPurchaseLoading.value,
                "user-fields-values": (_a = userFieldsValues.value) !== null && _a !== void 0 ? _a : [],
                visible: landingOrderFormVisibility.value,
                onCheckDiscount: checkDiscount,
                onFormSubmit: buyCourse,
                onHide: onOrderFormHide
            }, null, 8, ["can-use-promo-codes", "course", "landing", "loading-check-discount", "plan", "promocode", "purchase-loading", "user-fields-values", "visible"]));
        };
    }
});
